// theme change
const mobileMenuToggle = () => {
  document.querySelector('html').classList.toggle('topmenu_mobile_active')
}

export default mobileMenuToggle